export default __webpack_public_path__ + "static/media/Icon-Home.95295d24.svg";